"use client";

import { useConsent } from "@/lib/consent-context";

export function VideoConsentGate({ poster, className }: { poster?: string; className?: string }) {
  const { savePartial, openSettings } = useConsent();
  return (
    <div className={`relative size-full overflow-hidden bg-black ${className || ""}`}>
      {poster && (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={poster}
          alt="Video preview"
          aria-hidden
          className="absolute inset-0 size-full scale-105 object-cover opacity-25 blur-[2px]"
        />
      )}
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 p-6 text-center text-white">
        <p className="max-w-80 text-sm leading-normal text-white/90">
          This video is hosted on YouTube, which sets marketing cookies. Accept to watch it here.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          <button
            type="button"
            onClick={() => savePartial({ marketing: true })}
            className="bg-teal-07 hover:bg-teal-08 rounded-full px-5 py-2.5 text-sm font-semibold text-white transition-colors"
          >
            Accept &amp; play
          </button>
          <button
            type="button"
            onClick={openSettings}
            className="text-sm font-semibold text-white/70 underline underline-offset-4 transition-colors hover:text-white"
          >
            Manage cookies
          </button>
        </div>
      </div>
    </div>
  );
}
